export default __webpack_public_path__ + "static/platform-4bf3f3dce8873c4a43a3f34a9997cce3.png";